import React, { useEffect, useState } from "react";
import { Typography, Box, Button, Tabs, Tab, IconButton, Dialog, DialogTitle, DialogContent, TextField, InputAdornment, MenuItem, CircularProgress, DialogActions, Tooltip } from "@mui/material";
import { Visibility, Event, Edit, EventRepeat, Delete } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader'
import swal from "sweetalert";
import { fetchData, postFormData } from "../../../redux/apiSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import moment from 'moment-timezone';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const Campaigns = () => {
    const navigate = useNavigate();
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const pstDate = moment().tz('America/Los_Angeles'); // current PST time
    const [selectedDate, setSelectedDate] = useState(dayjs(pstDate.format('YYYY-MM-DD')));
    const [selectedTime, setSelectedTime] = useState(dayjs(pstDate.format('YYYY-MM-DD HH:mm:ss')));
    const [savedEmails, setSavedEmails] = useState([]);
    const [sentEmails, setSentEmails] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);
    const savedEmailscolumns = [
        { field: "template_name", headerName: "Template Name", flex: 1, minWidth: 150, valueGetter: (params) => params.row.template_name || "N/A" },
        { field: "subject", headerName: "Subject", flex: 1, minWidth: 150, valueGetter: (params) => params.row.subject || "N/A" },
        { field: "created_at", headerName: "Created At", flex: 1, minWidth: 200, valueFormatter: (params) => new Date(params.value).toLocaleString() },
        { field: "updated_at", headerName: "Updated At", flex: 1, minWidth: 200, valueFormatter: (params) => new Date(params.value).toLocaleString() },
        { field: "user", headerName: "User Name", flex: 1, minWidth: 150, valueGetter: (params) => params.row.user?.name || "N/A" },
        {
            field: "actions", headerName: "Action", flex: 1, minWidth: 200, sortable: false,
            renderCell: (params) => (
                <Box display="flex" justifyContent="center" gap={2}>
                    {[{ icon: <Visibility />, label: "View", onClick: () => handleOpenDialog(params.row) },
                    { icon: <Edit />, label: "Edit", onClick: () => handleEdit(params.row) },
                    { icon: <Delete />, label: "Delete", onClick: () => handleDelete(params.row) }]
                        .map(({ icon, label, onClick }, index) => (
                            <Tooltip key={index} title={label}>
                                <IconButton onClick={onClick ? onClick : undefined}>
                                    {icon}
                                </IconButton>
                            </Tooltip>
                        ))}
                </Box>
            )
        }
    ];
    const handleEdit = (email) => {
        navigate("/email-editor", { state: { content: email.content } });
    };
    const handleDelete = (row) => {
        setConfirmMessage(`Are you sure you want to delete "${row.template_name || "this template"}"?`);
        setConfirmAction(() => async () => {
            const token = localStorage.getItem("token");
            if (!token) return swal("Authentication Error", "No token found! Please log in again.", "error");
            const formData = new FormData();
            formData.append("templateId", row.id);
            try {
                const res = await dispatch(postFormData({ apiUrl: "/template/delete", formData })).unwrap();
                if (res?.success) {
                    swal("Deleted!", "Template deleted successfully!", "success");
                    setSavedEmails(prev => prev.filter(item => item.id !== row.id));
                    setSelectedRows(prev => prev.filter(item => item.id !== row.id));
                } else {
                    swal("Error!", res?.message?.message || res?.message || "Failed to delete the template.", "error");
                }
            } catch (err) {
                swal("Error!", err?.message || err?.error?.message || "An error occurred.", "error");
            }
        });
        setOpenConfirm(true);
    };

    const sentEmailsColumns = [
        { field: "name", headerName: "Name", flex: 1, minWidth: 200, valueGetter: (params) => params.row.user?.name || "N/A" },
        // { field: "status", headerName: "Status", flex: 1, minWidth: 150, valueGetter: (params) => params.row.mail_sent ? "Sent" : "Pending" },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 220,
            renderCell: (params) => {
                const isSent = params.row.mail_sent === 1;
                const status = isSent ? "Sent" : "Scheduled";
                const time = isSent ? params.row.created_at : params.row.schedule_time;
                // Format the date as MM-DD-YYYY H:mm
                const date = new Date(time);
                const formattedDate = isNaN(date) 
                    ? "Invalid Date"
                    : `${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}-${date.getFullYear()} ${date.getHours()}:${("0" + date.getMinutes()).slice(-2)}`;
                return (
                    <Box sx={{
                        color: isSent ? "#2A9005" : "#FFA500",
                        background: isSent ? "#D8F2D8" : "#FFF3CD",
                        borderRadius: "2px",
                        padding: "4px 10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start"
                    }}>
                        <Typography variant="caption" fontWeight="bold">{status}</Typography>
                        <Typography variant="caption">{formattedDate}</Typography>
                    </Box>
                );
            }
        },
        {
            field: "recipients", headerName: "Recipients Count", flex: 1, minWidth: 200,
            valueGetter: (params) => params.row.no_of_recipients || 0,
            renderCell: (params) => (
                <Box display="flex" alignItems="center" gap={2}> <Typography variant="body2">{params.row.no_of_recipients || 0}</Typography>
                    {params.row.file && (
                        <Tooltip title="View Recipients">
                            <IconButton size="small" onClick={() => handleViewRecipients(params.row)}>
                                <Visibility />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            )
        },
        // { field: "analytics", headerName: "Analytics", flex: 1, minWidth: 200, valueGetter: (params) => params.row.viewed_count || "N/A" },
        {
            field: "actions", headerName: "Action", flex: 1, minWidth: 200,
            renderCell: (params) => {
                const { mail_sent } = params.row;
                //  TO SHOW action buttons dynamically
                const actions = [
                    {
                        icon: <Visibility />,
                        tooltip: "View Email Content",
                        onClick: handleOpenDialog
                    },
                    {
                        icon: mail_sent ? <EventRepeat /> : <Event />,
                        tooltip: mail_sent ? "Reschedule" : "Schedule",
                        onClick: handleSendEmailClick
                    }
                ];
                return (
                    <Box display="flex" justifyContent="center" gap={2}>
                        {actions.map(({ icon, tooltip, onClick }, index) => (
                            <Box key={index} display="flex" flexDirection="column" alignItems="center">
                                <Tooltip title={tooltip}>
                                    <IconButton onClick={() => onClick(params.row)}>
                                        {icon}
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))}
                    </Box>
                );
            }
        }

    ];
    const [viewCols, setViewCols] = useState([]);
    const [viewRows, setViewRows] = useState([]);
    const [isViewRecipientsOpen, setIsViewRecipientsOpen] = useState(false);
    const handleViewRecipients = (report) => {
        if (!report?.file) {
            swal("Error!", "No file data found in the report.", "error");
            return;
        }
        try {
            const lines = atob(report.file).trim().split("\n");
            const headers = lines[0].split(",").map(h => h.trim());
            const rows = lines.slice(1).map((line, index) => {
                const values = line.split(",");
                const row = { id: index };
                headers.forEach((h, i) => (row[h] = values[i]?.trim()));
                return row;
            });
            setViewCols(headers.map(h => ({ field: h, headerName: h, flex: 1, minWidth: 120 })));
            setViewRows(rows);
            setIsViewRecipientsOpen(true);
        } catch (error) {
            console.log("Error decoding and parsing file:", error);
            swal("Error!", "Failed to decode recipient data.", "error");
        }
    };
    const dispatch = useDispatch();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);
    // const handleOpenDialog = (email) => {
    //     setSelectedEmail(email);
    //     setOpenDialog(true);
    // };
    const handleOpenDialog = (email) => {
        console.log("Selected Row:", email);
        console.log("Email Template:", email.email_templates);
        // FOR saved email template set content 
        if (email.email_templates?.content) {
            setSelectedEmail({
                content: email.email_templates.content,  // for saved email templates
            });
        } else {
            setSelectedEmail(email);  // For other emails
        }

        setOpenDialog(true);
    };


    const [openEmailPopup, setOpenEmailPopup] = useState(false);
    const [emailCsvData, setEmailCsvData] = useState({});
    const [emailCsvColumns, setEmailCsvColumns] = useState({});

    const handleSendEmailClick = (email) => {
        setOpenEmailPopup(true);
        setSelectedEmail(email);
        console.log(email.file, "Base64 Encoded CSV file");
        try {
            const decodedText = atob(email.file);
            console.log("Decoded CSV Data:", decodedText);

            // DIVIDE CSV into rows
            const rows = decodedText.split("\n").map(row => row.split(","));
            const headers = rows[0]; // First row = column headers

            // Map rows to objects 
            const data = rows.slice(1).map((row, index) => ({
                id: index + 1, // Unique ID for each row
                ...Object.fromEntries(row.map((val, i) => [headers[i], val]))
            }));
            // Save CSV data 
            setEmailCsvData((prevData) => ({
                ...prevData,
                [email.id]: data, // Store CSV data by email ID
            }));

            setEmailCsvColumns((prevColumns) => ({
                ...prevColumns,
                [email.id]: headers.map(header => ({
                    field: header,
                    headerName: header,
                    flex: 1
                })),
            }));

        } catch (error) {
            console.log("Error decoding CSV:", error.message);
        }
    };

    const [openScheduleSection, setOpenScheduleSection] = useState(false);
    const handleScheduleLaterClick = () => {
        setOpenScheduleSection(true); // Show the date/time 
    };
    useEffect(() => {
        if (activeTab === 1) {
            fetchSavedEmails();
        } else if (activeTab === 0) {
            fetchSentEmails();
        }
    }, [activeTab]);

    const fetchSavedEmails = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        handleFreezStart();
        const apiUrl = "/template/all";
        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);

            if (res && res.success === true) {
                setSavedEmails(res.data);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching saved emails:", error);
            swal("Error!", "Failed to fetch saved emails", "error");
        } finally {
            handleFreezStop();
        }
    };
    const [savedReports, setSavedReports] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [loadingSavedReports, setLoadingSavedReports] = useState(false);
    const fetchSavedReports = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        setLoadingSavedReports(true);
        handleFreezStart();
        const apiUrl = "/reports/all";
        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);
            if (res?.success) {
                const formattedRows = res.data.map((item, index) => ({
                    id: index + 1, // unique ID
                    reportName: item.report_name,
                    // dateRange: item.date_range,
                    dateRange: item.date_range
                        ? item.date_range
                            .split(" to ")
                            .map(date => new Date(date.replace(/-/g, "/")).toLocaleDateString())
                            .join(" to ")
                        : "N/A",
                    threshold: item.threshold || "N/A",
                    softwareUsed: item.software_used || "N/A",
                    milesRange: item.miles_range || "N/A",
                    file: item.file || "",
                }));
                setSavedReports(formattedRows);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching saved reports:", error);
            swal("Error!", "Failed to fetch saved reports", "error");
        } finally {
            setLoadingSavedReports(false);
            handleFreezStop();
        }
    };
    useEffect(() => {
        if (openEmailPopup) {
            fetchSavedReports();
        }
    }, [openEmailPopup]);

    const fetchSentEmails = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        handleFreezStart();
        const apiUrl = "/sentEmails/all";

        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);

            if (res && res.success === true) {
                setSentEmails(res.data);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.log("Error fetching sent emails:", error);
            swal("Error!", "Failed to fetch sent emails", "error");
        } finally {
            handleFreezStop();
        }
    };
    const handleSendEmail = async (scheduleLater = false, email, report) => {
        const apiUrl = "/sentEmails/send";
        const token = localStorage.getItem("token");
        console.log("token", token);

        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        if (!report || !report.id) {
            swal("Error!", "Please select a report before sending the email.", "error");
            return;
        }
        const subject = email?.subject || email?.email_templates?.subject || '';
        const content = email?.content || email?.email_templates?.content || '';
        const subjectPlaceholders = email?.subjectPlaceholders || [];
        const contentPlaceholders = email?.contentPlaceholders || [];
        const file = email?.file;
        const formData = new FormData();
        formData.append("subjectPlaceholders", JSON.stringify(subjectPlaceholders));
        formData.append("contentPlaceholders", JSON.stringify(contentPlaceholders));
        let csvFileUrl = file;
        if (!csvFileUrl) {
            console.log("No CSV file to upload.");
            swal("Error!", "No CSV file found.", "error");
            return;
        }
        let scheduleTime = "now";
        if (scheduleLater) {
            if (!selectedDate || !selectedTime) {
                swal("Error!", "Please select a date and time to schedule the email.", "error");
                return;
            }
            // scheduleTime = `${selectedDate}T${selectedTime}:00Z`;
            const combinedDateTime = `${selectedDate.format("YYYY-MM-DD")} ${selectedTime.format("HH:mm:ss")}`;
            const scheduledPST = moment.tz(combinedDateTime, "America/Los_Angeles");
            console.log("Scheduled PST DateTime:", scheduledPST.format());
            scheduleTime = scheduledPST.format("YYYY-MM-DDTHH:mm:ss");
        }
        formData.append("scheduleTime", scheduleTime);
        formData.append("file", csvFileUrl);
        formData.append("subject", subject);
        formData.append("content", content);
        formData.append("reportId", report.id);
        try {
            const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();

            if (res && res.success === true) {
                const successMessage = scheduleLater
                    ? "Email scheduled successfully!"
                    : "Email sent successfully!"
                swal("Success!", successMessage, "success").then(() => {
                    setSelectedReport(null);
                    setCsvRows([]);
                    setCsvColumns([]);
                    setOpenEmailPopup(false);
                    fetchSentEmails();
                });
            } else {
                console.log("Error response:", res);
                swal("Error!", res?.message || "Failed to send email", "error");
            }
        } catch (error) {
            console.log("Error sending email:", error);
            swal("Error!", "Failed to send email", "error");
        }
    };
    const [openCSVPopup, setOpenCSVPopup] = useState(false);
    const [csvRows, setCsvRows] = useState([]);
    const [csvColumns, setCsvColumns] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [confirmAction, setConfirmAction] = useState(() => () => { });
    //  open the confirmation dialog
    const openConfirmation = (message, action) => {
        setConfirmMessage(message);
        setConfirmAction(() => action); // Store  function to SHOW on confirm
        setOpenConfirm(true);
    };
    const handleCloseDialog = () => {
        setOpenEmailPopup(false);
        setSelectedReport(null);
        setCsvRows([]);
        setCsvColumns([]);
        setOpenScheduleSection(false);
    };
    const parseCSVFile = (file) => {
        try {
            const decoded = atob(file);
            const rows = decoded.trim().split(/\r?\n/).filter(Boolean);
            if (rows.length < 2) return { rows: [], columns: [] };
            const headers = rows[0].split(",").map(h => h.trim());
            const data = rows.slice(1).map((row, index) => {
                const values = row.split(",");
                return headers.reduce((acc, header, i) => {
                    acc[header] = values[i]?.trim() || "";
                    return acc;
                }, { id: index + 1 });
            });
            const columns = headers.map(header => ({
                field: header,
                headerName: header,
                flex: 1
            }));
            return { rows: data, columns };
        } catch (error) {
            console.log("CSV parsing error:", error);
            return { rows: [], columns: [] };
        }
    };
    const handleViewCSV = () => {
        const file = selectedReport?.file;
        if (!file) return alert("No CSV file found for this report.");
        const { rows, columns } = parseCSVFile(file);
        if (rows.length === 0) return alert("No valid data found in the CSV file.");
        setCsvRows(rows);
        setCsvColumns(columns);
        setOpenCSVPopup(true);
    };

    const ContentLayout =
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Campaigns
                </Typography>
                <Button variant="contained" className="commonBtn" onClick={() => navigate("/email-editor")}>CREATE EMAIL</Button>
            </Box>
            <Tabs value={activeTab} onChange={handleTabChange} TabIndicatorProps={{ style: { backgroundColor: "#2A9005" } }}>
                <Tab label="All Campaigns" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 0 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
                <Tab label="Saved Email Templates" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 1 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
            </Tabs>
            {activeTab === 0 && (
                <Box sx={{ width: "100%", mx: "auto", mt: 3 }}>
                    <DataGrid key={sentEmails.length} 
                        rows={sentEmails}
                        columns={sentEmailsColumns}
                        getRowId={(row) => row.id}
                        pageSizeOptions={[10, 20, 50]}
                        pagination
                        paginationMode="client"
                        autoHeight
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{ toolbar: { showQuickFilter: true } }}
                        sx={{
                            maxWidth: "100%",
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }}
                        onRowSelectionModelChange={(selectedIds) => {
                            const selectedData = sentEmails.filter(row => selectedIds.includes(row.id));
                            setSelectedRows(selectedData);
                        }}
                    />
                </Box>
            )}
            {activeTab === 1 && (
                <Box sx={{ width: "100%", mx: "auto", mt: 3 }}>
                    <DataGrid
                        rows={savedEmails}
                        columns={savedEmailscolumns}
                        getRowId={(row) => row.id}
                        pageSizeOptions={[10, 20, 50]}
                        pagination
                        paginationMode="client"
                        autoHeight
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{ toolbar: { showQuickFilter: true } }}
                        sx={{
                            maxWidth: "100%",
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }}
                        onRowSelectionModelChange={(selectedIds) => {
                            const selectedData = savedEmails.filter(row => selectedIds.includes(row.id));
                            setSelectedRows(selectedData);
                        }}
                    />
                </Box>
            )}
            <Dialog open={openDialog} fullWidth maxWidth="md">
                <DialogTitle>
                    Email Content
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenDialog(false)}
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedEmail && selectedEmail.content && selectedEmail.content !== "undefined" ? (
                        <div dangerouslySetInnerHTML={{ __html: selectedEmail.content }} />
                    ) : (
                        <Typography>No content available</Typography>
                    )}
                </DialogContent>
            </Dialog>
            <Dialog open={openEmailPopup} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Send Email
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleCloseDialog}
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            select
                            label="Select Report"
                            size="small"
                            variant="outlined"
                            value={selectedReport?.id || ""}
                            onChange={(e) => {
                                const selected = savedReports.find(
                                    report => report.id === parseInt(e.target.value)
                                );
                                setSelectedReport(selected);
                                if (selected?.file) {
                                    const { rows, columns } = parseCSVFile(selected.file);
                                    setCsvRows(rows);
                                    setCsvColumns(columns);
                                } else {
                                    setCsvRows([]);
                                    setCsvColumns([]);
                                }
                            }}
                            sx={{ minWidth: 250 }}
                        >
                            <MenuItem value="" disabled>
                                Select a Report
                            </MenuItem>
                            {loadingSavedReports ? (
                                <MenuItem disabled>
                                    <CircularProgress size={20} sx={{ mr: 1 }} /> Loading Reports...
                                </MenuItem>
                            ) : (
                                savedReports
                                    .filter(report => report?.id && report?.reportName?.trim())
                                    .map((report) => (
                                        <MenuItem key={report.id} value={report.id}>
                                            {report.reportName}
                                        </MenuItem>
                                    ))
                            )}
                        </TextField>
                        <TextField
                            label="To"
                            size="small"
                            variant="outlined"
                            placeholder="Recipient email id"
                            value={csvRows.length > 0 ? `${csvRows.length} Recipient${csvRows.length > 1 ? "s" : ""} Selected` : ""}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleViewCSV}>
                                            <Visibility />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="From"
                            size="small"
                            variant="outlined"
                            value="bruce.cornelious@myfreescorenow.com"
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            <Button variant="contained" className="send-button" onClick={() => {
                                if (!selectedReport || !selectedReport.id) {
                                    swal("Error!", "Please select a report before sending the email.", "error");
                                    return;
                                }
                                openConfirmation("Do you want to send the email now?", () =>
                                    handleSendEmail(false, selectedEmail, selectedReport)
                                );
                            }}>Send Now</Button>
                            <Button variant="outlined" className="commonOutlinedBtn" onClick={handleScheduleLaterClick}>Schedule for Later</Button>
                        </Box>
                        {openScheduleSection && (
                            <Box sx={{ mt: 1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Select Date"
                                        value={selectedDate}
                                        disablePast
                                        onChange={(newDate) => setSelectedDate(newDate)}
                                        sx={{ width: "100%", mb: 2 }}
                                    />
                                    <TimePicker
                                        label="Select Time"
                                        value={selectedTime}
                                        onChange={(newTime) => setSelectedTime(newTime)}
                                        sx={{ width: "100%" }}
                                    />
                                </LocalizationProvider>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Button variant="contained" className="schedule-button" onClick={() => {
                                        if (!selectedReport || !selectedReport.id) {
                                            swal("Error!", "Please select a report before sending the email.", "error");
                                            return;
                                        }
                                        openConfirmation("Do you want to schedule the email?", () =>
                                            handleSendEmail(true, selectedEmail, selectedReport)
                                        );
                                    }}>Schedule</Button>
                                    <Button variant="outlined" className="commonOutlinedBtn" onClick={() => setOpenScheduleSection(false)}>Cancel</Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openCSVPopup} onClose={() => setOpenCSVPopup(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    CSV Data
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenCSVPopup(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {csvRows.length ? (
                        <Box sx={{ width: "100%", overflowX: "auto", height: 400 }}>
                            <DataGrid
                                rows={csvRows}
                                columns={csvColumns}
                                hideFooter
                                disableColumnMenu
                                disableSelectionOnClick
                                disableRowSelectionOnClick
                                sx={{
                                    "& .MuiDataGrid-columnHeaders": {
                                        backgroundColor: "#2E67BC",
                                        color: "#fff",
                                        fontWeight: "bold"
                                    }
                                }}
                            />
                        </Box>
                    ) : (
                        <Typography>No CSV data available.</Typography>
                    )}
                </DialogContent>
            </Dialog>
            <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>{confirmMessage}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)} color="primary">Cancel</Button>
                    <Button onClick={() => { confirmAction(); setOpenConfirm(false); }} color="error" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={isViewRecipientsOpen} onClose={() => setIsViewRecipientsOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Recipient List
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setIsViewRecipientsOpen(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box style={{ height: 400, width: "100%" }}>
                        <DataGrid rows={viewRows} columns={viewCols} pageSize={10} sx={{
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold"
                            }
                        }} />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                    onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div></>
    );

};

export default Campaigns;